import { MyIntegrationsResponseDto } from './types';
import { useApiQuery } from 'theSource/utils';
import { GET_MY_INTEGRATIONS_QUERY_KEY } from './utils';

export const useMyIntegrationsQuery = () => {
  const {
    data: integrationsResponse,
    isLoading: isLoadingIntegrations,
    isFetching: isFetchingIntegrations,
  } = useApiQuery<MyIntegrationsResponseDto>({
    queryKey: GET_MY_INTEGRATIONS_QUERY_KEY,
    endpoint: '/my_integrations',
  });

  return {
    integrationsResponse,
    isLoadingIntegrations,
    isFetchingIntegrations,
  };
};
